import { render, staticRenderFns } from "./branches.vue?vue&type=template&id=1e21b9cc"
import script from "./branches.vue?vue&type=script&lang=js"
export * from "./branches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports